var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShadedGlasses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2065.969,
    height: 735.043,
    viewBox: "0 0 2065.969 735.043",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_262",
    "data-name": "Raggruppa 262",
    transform: "translate(1560.164 -174.173)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4",
    "data-name": "Raggruppa 4",
    transform: "translate(-1560.162 174.173)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_6",
    "data-name": "Tracciato 6",
    d: "M13107.4-577.68s104.817-.255,412.433-70.059,616.822,54.9,616.822,54.9v102.861s-8.865,46.767-69.966,98-21.5,434.62-354.469,455.524S13331.6-30.81,13331.6-30.81s-148.76-167.862-170.667-335.378c-11.62-39.511-58.907-30.347-57.236-31.493,0,0-3-24.509-.012-69.822.935-14.182-.557-31.678,0-47.551C13104.85-548.463,13107.4-577.68,13107.4-577.68Z",
    transform: "translate(-12070.689 668.967)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_7",
    "data-name": "Tracciato 7",
    d: "M14137.082-577.684s-112.405-.251-420.023-70.055-616.826,54.9-616.826,54.9v102.861s8.873,46.767,69.972,98,21.5,434.62,354.468,455.524S13905.3-30.81,13905.3-30.81s148.757-167.862,170.668-335.378c11.617-39.511,58.693-30.476,57.373-31.516S14137.082-577.684,14137.082-577.684Z",
    transform: "translate(-13100.232 668.967)",
    fill: "#d9d9d9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3",
    "data-name": "Raggruppa 3",
    transform: "translate(-1361.849 233.46)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_6-2",
    "data-name": "Tracciato 6",
    d: "M13106.676-590.749s89.813-.219,353.386-60.029,528.515,47.037,528.515,47.037v88.135s-7.6,40.072-59.949,83.968-18.425,372.4-303.72,390.307-326.132-80.843-326.132-80.843S13171.313-266,13152.543-409.537c-9.957-33.854-50.473-26-49.043-26.984,0,0-2.566-21-.011-59.825.8-12.152-.475-27.143,0-40.743C13104.49-565.715,13106.676-590.749,13106.676-590.749Z",
    transform: "translate(-12218.393 668.967)",
    fill: "#bab9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_7-2",
    "data-name": "Tracciato 7",
    d: "M13988.634-590.753s-96.313-.215-359.889-60.026-528.514,47.037-528.514,47.037v88.135s7.6,40.072,59.952,83.968,18.423,372.4,303.716,390.307,326.137-80.843,326.137-80.843S13917.5-266,13936.27-409.537c9.952-33.854,50.291-26.113,49.159-27S13988.634-590.753,13988.634-590.753Z",
    transform: "translate(-13100.231 668.967)",
    fill: "#bab9b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1",
    "data-name": "Raggruppa 1",
    transform: "translate(-1221.844 277.086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_6-3",
    "data-name": "Tracciato 6",
    d: "M13106.159-600.133s79.037-.192,310.994-52.828,465.107,41.394,465.107,41.394V-534s-6.685,35.265-52.758,73.895-16.212,327.722-267.283,343.485-287.007-71.145-287.007-71.145-112.171-126.575-128.689-252.89c-8.762-29.793-44.419-22.883-43.16-23.747,0,0-2.261-18.481-.011-52.648.706-10.694-.417-23.887,0-35.855C13104.236-578.1,13106.159-600.133,13106.159-600.133Z",
    transform: "translate(-12324.435 668.967)",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_7-3",
    "data-name": "Tracciato 7",
    d: "M13882.059-600.136s-84.759-.189-316.715-52.824-465.109,41.394-465.109,41.394V-534s6.688,35.265,52.758,73.895,16.212,327.722,267.283,343.485,287.009-71.145,287.009-71.145,112.172-126.575,128.69-252.89c8.761-29.793,44.26-22.981,43.265-23.765S13882.059-600.136,13882.059-600.136Z",
    transform: "translate(-13100.234 668.967)",
    fill: "#7f7f7f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadedGlasses);
export default __webpack_public_path__ + "static/media/ShadedGlasses.d96a9b4f1a1f0e1d38c21f6e16401ebd.svg";
export { ForwardRef as ReactComponent };